const getRegExp = decimalPlaces => new RegExp(`^(\\d+(\\.\\d{0,${decimalPlaces}})?|\\.?\\d{1,${decimalPlaces}})$`);

export default function validateDecimalPlaces(value, decimalPlaces) {
  return getRegExp(decimalPlaces).test(value);
}
